module.exports = __webpack_public_path__ + "imgs/leaf-header-background.f9916d176240af780f9f54cb48bcf42d.jpg";